/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mail_Compose_ErrorInputs */

const en_mail_compose_error = /** @type {(inputs: Mail_Compose_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not process the email.`)
};

const de_mail_compose_error = /** @type {(inputs: Mail_Compose_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die E-Mail konnte nicht verarbeitet werden.`)
};

/**
* | output |
* | --- |
* | "Could not process the email." |
*
* @param {Mail_Compose_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mail_compose_error = /** @type {((inputs?: Mail_Compose_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mail_Compose_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_mail_compose_error(inputs)
	return en_mail_compose_error(inputs)
});